export function compileProducts(arr) {
  console.log(arr);
  const result = arr.groups.reduce((acc, obj) => {
    acc = acc || [];
    if (!obj.base.element.props) return false;
    const { id: productKey, props: { price } } = obj.base.element;
    const { quantity } = obj.base;
    const product = {
      // item_name,
      productKey,
      price,
      // item_brand,
      currency: 'UAH',
      quantity: Number(quantity),
      // ...categoriesPrettifier(categoriesTitles),
    };
    acc.push(product);
    return acc;
  }, []);
  return result;
}
